import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';

const appName = process.env.REACT_APP_NAME

export const setCookie = (name: string, value:string, expires: number = 30): boolean => {
    const hashedName: string = `_${CryptoJS.MD5(`${appName}~${name}`).toString()}`
    
    try {
        Cookies.set(hashedName, value, {
            expires: expires, 
            secure: true, 
            sameSite: 'Strict' 
        });
    } catch(e) {
        return false
    }
    return true
}

export const getCookie = (name: string) => {
    const hashedName: string = `_${CryptoJS.MD5(`${appName}~${name}`).toString()}`
    return Cookies.get(hashedName)
}

export const removeCookie = (name: string) => {
    const hashedName: string = `_${CryptoJS.MD5(`${appName}~${name}`).toString()}`
    return Cookies.remove(hashedName)
}